import { lddGlobalSessionInfo, NavObjectType } from "../../navigationTypes"
import { loginWithPassCode } from "../../../dr/Components/drFuncs";

export const getBuilderBuyerDocs = async(msgID: string, SessionInfo: lddGlobalSessionInfo): Promise<any[]> => {
    if (!msgID || isNaN(Number(msgID))) {
        console.log("Invalid MsgID, couldn't fetch builder docs...");
        return [];
    }
    try {
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.firm.id}/${SessionInfo.user.account}/listbuyerdoc?SessionID=${SessionInfo.sid}&MsgID=${msgID}`);
        if (response) {
            const responseJSON = await response.json();
            if (!responseJSON.ok) throw "Failed to fetch buyer's documents.";
            return responseJSON.result;
        }
    } catch (e) {
        console.log(e);
    }
    return [];
}

export const getBuilderDocs = async(msgID: string, SessionInfo: lddGlobalSessionInfo, page: NavObjectType, passCode: string): Promise<any> => {
    if (!msgID || isNaN(Number(msgID))) {
        console.log("Invalid MsgID, couldn't fetch builder docs...");
        return [];
    }
    try {
        let url;
        if (SessionInfo && passCode > "") {
            await loginWithPassCode(passCode);
        }
        if (SessionInfo && (page.params?.PassCode !== "1" && !(passCode > ""))) {
            url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.firm.id}/${SessionInfo.user.account}/builderdoc?SessionID=${SessionInfo.sid}&MsgID=${msgID}`
        } else {
            url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/passcode/builderdoc?PassCode=1&MsgID=${msgID}`
        }
        const response = await fetch(url);
        if (response) {
            const responseJSON = await response.json();
            if (!responseJSON.ok) throw "Failed to fetch builder documents.";
            return responseJSON.result;
        }
    } catch (e) {
        console.log(e);
    }
    return [];
}

export const deleteBuyerDoc = async (docID: number, msgID: string, SessionInfo: lddGlobalSessionInfo): Promise<boolean> => {
    try {
        const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.firm.id}/${SessionInfo.user.account}/buyerdoc?SessionID=${SessionInfo.sid}&DocID=${docID}&MsgID=${msgID}`;
        const response = await fetch(url, {method: 'DELETE'});
        if (response) {
            const responseJSON = await response.json();
            if (!responseJSON.ok) throw "Failed to delete builder document.";
            return responseJSON.result;
        }
    } catch (error) {
        console.log(error);
        return false;
    }
    return true;
}

export const uploadBuyerDoc = async (msgID: string, SessionInfo: lddGlobalSessionInfo, file: File, uploadFileNewName: string): Promise<boolean> => {
    try {
        const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.firm.id}/${SessionInfo.user.account}/buyerdoc?SessionID=${SessionInfo.sid}&MsgID=${msgID}`;
        const formData = new FormData();
        formData.append("file", file);
        formData.append("filename", uploadFileNewName);
        const response = await fetch(url, {method: 'POST', body: formData});
        if (response) {
            const responseJSON = await response.json();
            if (!responseJSON.ok) throw "Failed to upload the builder document.";
            return responseJSON.result;
        }
    } catch (error) {
        console.log(error);
        return false;
    }
    return true;
}